import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ChevronRight from 'react-feather/dist/icons/chevron-right.js';
import ChevronLeft from 'react-feather/dist/icons/chevron-left.js';
import {createLocation} from 'history';

import Date from '../../../../shared/components/Moment/Date.jsx';
import DefaultLayout from '../../Layout/DefaultLayout.jsx';
import Header from '../../../components/Header/Header.jsx';
import Sidebar from '../Sidebar.jsx';

import {generate} from '../../../routes.js';
import {loadArticle} from '../../../components/Blog/actions.js';

import './Article.scss';

class Article extends Component {
  componentDidMount() {
    this.props.loadArticle(this.props.match.params.slug);
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (!this.props.loadingArticle && prevProps.match.params.slug !== this.props.match.params.slug) {
      this.props.loadArticle(this.props.match.params.slug);
    }

    if (!this.props.loadingArticle && prevProps.loadingArticle && null === this.props.currentArticle) {
      this.redirectToBlogMainPage()
    }

    if (!this.props.currentArticle) {
      this.redirectToBlogMainPage()
    }
  }

  redirectToBlogMainPage = () => {
    this.props.history.push(createLocation(
      generate({name: 'blog'})
    ));
  };

  generateLink = (slug) => {
    return generate({name: 'blog-article', parameters: {slug: slug}});
  };

  render() {
    const {currentArticle, nextArticle, prevArticle, ...props} = this.props;

    const title = currentArticle?.meta_title ?? 'Twineeds | Blog sur le Conseil Indépendant, le Recrutement & le Freelance';
    const description = currentArticle?.meta_description ?? 'Explorez nos articles sur le freelancing, le conseil indépendant et les évolutions du recrutement. Un blog dédié aux consultants experts et entreprises.';
    const tags = currentArticle?.tags?.length ? currentArticle.tags : [];
    const headerBrief = <Fragment>
      {tags.length > 0 ?
        <ul className="tags-list d-flex justify-content-center justify-content-md-start p-0">
          {tags.map((tag, index) => <li key={tag.id || index}>#{tag.name}</li>)}
        </ul> : null
      }
      <p>{currentArticle?.excerpt ?? ''}</p>
    </Fragment>;

    return <DefaultLayout showSidebarMenu={false} helmet={{title, description}} className="article-layout">
      <Header
        brief={headerBrief}
        imageAlt={currentArticle?.title ?? ''}
        imageSrc={currentArticle?.picture?.header ?? ''}
        title={currentArticle?.title ?? ''}
      />
      <div className="container">
        <div className="row mt-5">
          <section className="col-sm-8">
            <p>
              Publié le <Date format="dd/MM/yyyy"
                date={currentArticle?.publishing_date ?? ''}/>
            </p>
            <div
              className="article-body mb-5"
              dangerouslySetInnerHTML={{__html: currentArticle?.body ?? ''}}
            />
            {(prevArticle || nextArticle) &&
              <div className="nav-links d-flex flex-column flex-md-row justify-content-md-between my-5">
                {prevArticle &&
                  <Link className="btn btn-primary prev" to={this.generateLink(prevArticle.slug)}>
                    <ChevronLeft/>Article précédent
                  </Link>
                }
                {nextArticle &&
                  <Link className="btn btn-primary next" to={this.generateLink(nextArticle.slug)}>
                    Article suivant<ChevronRight/>
                  </Link>
                }
              </div>
            }
          </section>
          <Sidebar articles={props.articles.slice(0, 5)} className="col-sm-4 offset-md-1 col-md-3"/>
        </div>
      </div>
    </DefaultLayout>;
  }
}

export default connect(
  state => ({
    articles: state.blog.articles,
    currentArticle: state.blog.currentArticle,
    loadingArticle: state.blog.loadingArticle,
    nextArticle: state.blog.nextArticle,
    prevArticle: state.blog.prevArticle,
  }),
  dispatch => ({
    loadArticle: (slug) => dispatch(loadArticle(slug)),
  })
)(Article);